(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

  const showToast = (message) => {
    const toast = qs('#omikaro-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  const updateCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      qsa('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    } catch (_) {}
  };

  const setMenu = (open) => {
    const toggle = qs('[data-menu-toggle]');
    const menu = qs('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    menu.hidden = !open;
    menu.classList.toggle('is-open', open);
  };

  document.addEventListener('click', async (event) => {
    const menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      const menu = qs('[data-mobile-menu]');
      setMenu(menu?.hidden !== false);
      return;
    }

    const mobileMenuLink = event.target.closest('[data-mobile-menu] a');
    if (mobileMenuLink) setMenu(false);

    const minus = event.target.closest('[data-qty-minus]');
    const plus = event.target.closest('[data-qty-plus]');
    if (minus || plus) {
      const button = minus || plus;
      const input = button.parentElement?.querySelector('input');
      if (!input) return;
      const current = Math.max(1, Number(input.value || 1));
      input.value = minus ? Math.max(1, current - 1) : current + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const cartMinus = event.target.closest('[data-cart-minus]');
    const cartPlus = event.target.closest('[data-cart-plus]');
    if (cartMinus || cartPlus) {
      const button = cartMinus || cartPlus;
      const input = document.getElementById(button.dataset.target);
      if (!input) return;
      const current = Math.max(0, Number(input.value || 0));
      input.value = cartMinus ? Math.max(0, current - 1) : current + 1;
      return;
    }

    const quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault();
      const form = quickAdd.closest('form');
      if (!form) return;

      quickAdd.disabled = true;
      quickAdd.classList.add('is-added');
      quickAdd.innerHTML = '<span>✓</span><span class="quick-add__text">Added</span>';

      try {
        const body = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body
        });
        if (!response.ok) throw new Error('Add failed');
        const item = await response.json();
        await updateCartCount();
        showToast(`${item.product_title || 'Product'} added to cart`);
      } catch (_) {
        showToast('Could not add that item. Please try again.');
      } finally {
        window.setTimeout(() => {
          quickAdd.disabled = false;
          quickAdd.classList.remove('is-added');
          quickAdd.innerHTML = '<span>+</span><span class="quick-add__text">Add</span>';
        }, 1300);
      }
      return;
    }

    const mobileAdd = event.target.closest('[data-mobile-add]');
    if (mobileAdd) {
      const form = qs('.product-form');
      if (form) form.requestSubmit(qs('[name="add"]', form));
      return;
    }

    const imageButton = event.target.closest('[data-product-image]');
    if (imageButton) {
      const root = imageButton.closest('[data-product-root]');
      const main = qs('[data-main-image] img', root);
      if (main) main.src = imageButton.dataset.productImage;
      qsa('[data-product-image]', root).forEach((btn) => btn.classList.remove('is-active'));
      imageButton.classList.add('is-active');
    }
  });

  const setupProductForm = () => {
    const root = qs('[data-product-root]');
    const form = qs('.product-form', root);
    const json = qs('[data-product-json]', root);
    if (!root || !form || !json) return;

    let product;
    try { product = JSON.parse(json.textContent); } catch (_) { return; }

    const variantId = qs('[data-variant-id]', form);
    const price = qs('[data-product-price]', root);
    const compare = qs('[data-product-compare]', root);
    const mobilePrice = qs('[data-mobile-price]', root);
    const submit = qs('[data-product-submit]', form);
    const mobileAdd = qs('[data-mobile-add]', root);
    const buyNow = qs('[data-buy-now]', form);

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          maximumFractionDigits: 0
        }).format(cents / 100);
      } catch (_) {
        return `₹${Math.round(cents / 100)}`;
      }
    };

    const findVariant = () => {
      const selected = {};
      qsa('input[data-option-position]:checked', form).forEach((input) => {
        selected[`option${input.dataset.optionPosition}`] = input.value;
      });

      return product.variants.find((variant) => {
        return Object.entries(selected).every(([key, value]) => variant[key] === value);
      }) || product.variants[0];
    };

    const syncVariant = () => {
      const variant = findVariant();
      if (!variant) return;

      if (variantId) variantId.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price);

      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = formatMoney(variant.compare_at_price);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (mobileAdd) {
        mobileAdd.disabled = !variant.available;
        mobileAdd.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (buyNow) {
        buyNow.disabled = !variant.available;
        buyNow.textContent = variant.available ? 'Buy it now' : 'Sold out';
      }
    };

    qsa('input[data-option-position]', form).forEach((input) => {
      input.addEventListener('change', syncVariant);
    });

    syncVariant();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.product-form');
    if (!form) return;

    const submitter = event.submitter;
    const buyNow = submitter && submitter.matches('[data-buy-now]');
    const submit = qs('[name="add"]', form);
    if (!submit || submit.disabled) return;

    event.preventDefault();
    const original = submitter ? submitter.textContent : submit.textContent;
    const button = buyNow ? submitter : submit;
    button.disabled = true;
    button.textContent = buyNow ? 'Opening checkout…' : 'Adding…';

    try {
      const body = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body
      });

      if (!response.ok) throw new Error('Could not add item');
      const item = await response.json();
      await updateCartCount();

      if (buyNow) {
        // Razorpay Magic Checkout can intercept the storefront Buy Now button.
        // If it does not, this safe fallback still takes the customer to Shopify checkout.
        window.location.href = '/checkout';
        return;
      }

      showToast(`${item.product_title || 'Product'} added to cart`);
      button.textContent = 'Added ✓';
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = original;
      }, 1200);
    } catch (_) {
      button.disabled = false;
      button.textContent = original;
      showToast(buyNow ? 'Could not start checkout. Please try again.' : 'Could not add that item. Please try again.');
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    setupProductForm();
  });
})();
